document.addEventListener('DOMContentLoaded', () => {
    const script = document.createElement('script');
    script.type = 'application/ld+json';
    script.text = `
    {
        "@context": "https://schema.org",
        "@type": "WebSite",
        "name": "Today's Shopping Choice",
        "alternateName": ["TSC", "shoptsc"],
        "url": "https://www.tsc.ca/",
        "logo": "https://src.tscimg.ca/Content/en_CA/Assets/logos/tsc-logo-black-small.svg",
        "sameAs": [
            "https://www.twitter.com/shoptsc",
            "https://www.instagram.com/shoptsc",
            "https://www.youtube.com/shoptsc",
            "https://www.pinterest.ca/shoptsc"
        ],
        "potentialAction": {
            "@type": "SearchAction",
            "target": "https://www.tsc.ca/products?keyword={query}",
            "query-input": "required name=query"
        }
    }`;

    document.head.appendChild(script);
});

export {};
